import React, { useEffect, useState } from 'react';
import DepartmentsHeader from './DepartmentsHeader/DepartmentsHeader';
import { ApiCenter } from '../api/ApiCenter';
import { DownOutlined } from '@ant-design/icons';
import classes from './style/Departments.module.css';
import type { MenuProps } from 'antd';
import { Button, Dropdown, Space } from 'antd';
import { IDepartmentsProps, UsersProps } from '../../types/Departments';
import { nanoid } from 'nanoid';
import DepartmentsCard from './DepartmentsCard/DepartmentsCard';
import FreeUsersModal from './FreeUsersModal/FreeUsersModal';
import { ICategories } from '../../types/TestType';

export interface modalProps {
  id: number | null;
  title: string;
  category_id: number;
}

const Departments = () => {
  const Apistart = new ApiCenter();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [data, setData] = useState<IDepartmentsProps[]>([]);
  const [modalProps, setModalProps] = useState<modalProps | null>();
  const [items, setItems] = useState<MenuProps['items'] | null>(null);
  const [categories, setCategories] = useState<ICategories[] | null>(null);
  const constructLink = (categoryId: number, id?: number | null) => {
    const baseUrl = 'departments';
    let link = baseUrl;
    if (id) {
      link += `/${id}`;
    }
    switch (categoryId) {
      case 1:
        break;
      default:
        link += `?category_id=${categoryId}`;
        break;
    }
    return link;
  };
  interface MyObject {
    [key: string]: any;
  }
  function addKeyToObjectsArray(objectsArray: MyObject[]): { [key: string]: any; key: number }[] {
    return objectsArray.map((obj) => {
      return { ...obj, key: obj.id, label: obj.title };
    });
  }

  const fetchData = async (value: number) => {
    try {
      const response = await Apistart.GET_API(constructLink(value), 'GET');
      if (response.success) {
        setData(response.data.departments);
        setCategories(response.data.categories);
        setItems(addKeyToObjectsArray(response.data.categories));
      } else {
        // eslint-disable-next-line no-console
        console.log('Что-то пошло не так!');
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
  const handleChange = (value: number) => {
    fetchData(value);
  };
  const findDepartment = (id: number | null): number => {
    const index = data.findIndex((department: IDepartmentsProps) => department.id === id);
    return index !== -1 ? index : -1;
  };
  const modalOpen = (id: number | null, title: string, category_id: number) => {
    setModalProps({ id: id || null, title: title, category_id: category_id });
    setShowModal(true);
  };
  const modalClose = () => {
    setShowModal(false);
  };
  const getUsers = (id: number | null, userId?: number, userChoises?: number[]): number[] => {
    const users = data[findDepartment(id)]?.users?.filter((user: UsersProps) => user.id != userId);
    if (id && userChoises && userChoises.length) {
      return users.map((user: UsersProps) => user.id).concat(userChoises);
    }
    if (id && users && users.length) {
      return users.map((user: UsersProps) => user.id);
    } else {
      return [];
    }
  };
  const getFullUsers = (id: number | null, userId?: number, peoples?: UsersProps[]) => {
    const users = data[findDepartment(id)]?.users?.filter((user: UsersProps) => user.id != userId);
    if (id && peoples) {
      return users.concat(peoples);
    }
    return users;
  };

  const changeDepartment = async (
    id: number | null,
    title: string,
    category_id: number,
    userId?: number,
    userChoises?: number[],
    peoples?: UsersProps[]
  ) => {
    const methode = id !== null ? 'PUT' : 'POST';
    const sendValue = {
      category_id: category_id,
      title: title,
      users: getUsers(id, userId, userChoises) || [],
    };
    try {
      const response = await Apistart.GET_API(constructLink(1, id), methode, sendValue);
      if (response.success) {
        if (showModal) {
          setShowModal(false);
        }
        const tempDepartment = data[findDepartment(id)];
        const newData = () => {
          const newData = [...data];
          const currentIndex = newData.findIndex((item) => item.id === id);
          newData.splice(currentIndex, 1);
          newData.splice(currentIndex, 0, {
            ...tempDepartment,
            id: id || response.data.id,
            title: title,
            users: getFullUsers(id, userId, peoples),
          });

          return newData;
        };
        setData(newData());
      } else {
        // eslint-disable-next-line no-console
        console.log('Что-то пошло не так!');
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
  useEffect(() => {
    fetchData(1);
  }, []);
  const onClick: MenuProps['onClick'] = ({ key }) => {
    const scrollTop = window.scrollTo;
    const initialState: IDepartmentsProps = {
      category_id: Number(key),
      id: null,
      title: '',
      users: [],
    };
    const newData = () => {
      return [{ ...initialState }, ...data.slice()];
    };
    setData(newData());
    scrollTop(0, 0);
  };
  const maxHeigth = () => {
    let heigth = 0;
    let count = 1;
    const divider = window.innerWidth > 1420 ? 4 : 3;
    const maxHeigthList = [];
    for (const item of data) {
      const index = data.findIndex((card) => card.id === item.id) + 1;
      heigth += item.users.length * 30 + 178 + 20;
      if (index / count === Math.ceil(data.length / divider) || data.length === index + 1) {
        count++;
        maxHeigthList.push(heigth);
        heigth = 0;
      }
    }
    return Math.max(...maxHeigthList) + 100;
  };

  if (!data) {
    return <>Загрузка</>;
  }
  const maxWidth = () => {
    if (data.length === 2) {
      return { widthWrapper: 50, widthCard: 50 };
    }
    if (data.length === 3) {
      return { widthWrapper: 75, widthCard: 33 };
    }
    return { widthWrapper: 100, widthCard: 25 };
  };
  return (
    <div>
      <div className={classes.HeaderTitle}>
        <h1>Отделы</h1>
        <div>
          {items && (
            <div>
              <Dropdown menu={{ items, onClick }}>
                <Button type="primary" onClick={() => onClick}>
                  <Space>
                    Создать новый отдел
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown>
            </div>
          )}
        </div>
      </div>
      {categories && <DepartmentsHeader categories={categories} handleChange={handleChange} />}
      <div>
        <div
          className={classes.wrapperCards}
          style={{ maxHeight: `${maxHeigth()}px`, maxWidth: `${maxWidth().widthWrapper}%` }}
        >
          {data.map((department) => {
            const key = nanoid();
            return (
              <div
                key={key}
                style={{
                  maxWidth: `calc(${maxWidth().widthCard}% - 20px)`,
                  width: `calc(${maxWidth().widthCard}% - 25px)`,
                }}
                className={classes.card}
              >
                <DepartmentsCard
                  category_title={categories?.[department.category_id - 2]?.['title'] || ''}
                  department={department}
                  changeDepartment={changeDepartment}
                  modalSwitch={modalOpen}
                />
              </div>
            );
          })}
        </div>
      </div>
      {showModal && modalProps && (
        <FreeUsersModal
          modalClose={modalClose}
          changeDepartment={changeDepartment}
          modalProps={modalProps}
        />
      )}
    </div>
  );
};

export default Departments;
